import { axiosPost, axiosGet, // TO DO unused import // TO DO lazy load component
    axiosPostAuthorize, axiosGetAuthorize } from '../AxiosRequests';
import { AddUsers, UpdateUsers, GetUsersList, DeleteUsers, GetUsersById, GetUsersByEmailAddress,UpdateUserStatus } from '../ApiEndPoints';

export default class UserServices {

    async addUsers(request) {
        return axiosPostAuthorize(AddUsers, request);
    }

    async updateUsers(request) {
        return axiosPostAuthorize(UpdateUsers, request);
    }

    async deleteUsers(request) {
        return axiosPostAuthorize(DeleteUsers, request);
    }

    async getUsersList(request) {
        return axiosPostAuthorize(GetUsersList, request);
    }

    async getUsersById(request) {
        return axiosGetAuthorize(GetUsersById, request);
    }
    async getUsersByEmailAddress(request) {
        return axiosGetAuthorize(GetUsersByEmailAddress, request);
    }
    async updateUserStatus(request) {
        return axiosPostAuthorize(UpdateUserStatus, request);
    }   
}